"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var family = {
  opensans: '"Open Sans", sans-serif, Tahoma, Arial'
};
var _default = family;
exports["default"] = _default;